import * as React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Modal from '@mui/material/Modal'
// generate code uuid
import { v4 as uuidv4 } from 'uuid'
import { useDispatch, useSelector } from 'react-redux'
import { getDataUserOrganization } from '../../../../app/services/Organization/getUserDataOrganizationCorpEntities'
import { updateUserStatusDeletedOrganizationCorpEntities } from '../../../../app/services/Organization/updateUserStatusDeletedOrganizationCorpEntities'
import { isSameUserLogged } from '../../../../utils/UserTools'
import { logEvent } from '../../../../utils/LogEvents'
import { unassignUserSubscriberCorpEntity } from '../../../../app/services/Suscriber/unassignUserSubscriberCorpEntity'
import {
  setErrorTextSnackBar,
  setRequestTextSnackBar,
  setSuccessTextSnackBar
} from '../../../../redux/actions/app'
import { useNavigate, useParams } from 'react-router-dom'
import useStyleConfirmDisableSuscriber from './Styles/useStyleConfirmDisableUserSuscriber'
import CloseIcon from '@mui/icons-material/Close'
import { getSuscriberRefID } from '../../../../redux/actions/Suscriber'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  height: 200,
  bgcolor: 'white',
  p: 4,
  borderRadius: '8px',
  boxShadow: '0px 0px 4px rgba(36, 55, 143, 0.4)'
}

export default function ModalDisableUser ({
  setLoading,
  setRows,
  openModalDisableUser,
  setOpenModalDisableUser
}) {
  const classes = useStyleConfirmDisableSuscriber()

  const { id } = useParams()
  const navigate = useNavigate()

  const dispatch = useDispatch()
  const organizationState = useSelector((state) => state.organization)

  const handleCloseModalDisableUser = async () => {
    setOpenModalDisableUser(false)
  }

  // finish proccess by error request
  const requestFailure = (text) => {
    // error
    dispatch(setRequestTextSnackBar())
    dispatch(setErrorTextSnackBar(text))
    setLoading(false)
  }

  const refreshPage = () => {
    navigate(0)
  }

  // get info suscriber with refid
  const handleGetSuscriber = async () => {
    const params = {
      clicod: id
    }
    const response = await dispatch(getSuscriberRefID(params))
    return response
  }

  // const handleGetSuscriber = async () => {
  //   try {
  //     const params = {
  //       clicod: id
  //     }
  //     const response = await getSuscriberRefId(params)
  //     return response.data
  //   } catch (err) {
  //     return null
  //   }
  // }

  // get user verify exists and get logginaccount Id
  const getLogginAccountID = async (userid) => {
    try {
      await getDataUserOrganization(userid)
    } catch (error) {
      error.response?.data?.codeMessageLanguage === 'organizationUserNotFound'
        ? requestFailure('El usuario no existe')
        : requestFailure('Ocurrió un error, intente nuevamente')
      return 'error'
    }
  }
  // change status user organization by 'DELETED
  const handleChangeStatusUser = async (myuuid) => {
    try {
      const response = await updateUserStatusDeletedOrganizationCorpEntities(
        organizationState.user.user_id
      )

      await logEvent(
        'CGI - updateUserStatusDeletedOrganizationCorpEntities',
        { userid: organizationState.user.user_id, action: 'DELETED' },
        myuuid
      )
      return response
    } catch (error) {
      await logEvent(
        'CGI - updateUserStatusDeletedOrganizationCorpEntities',
        {
          body: { userid: organizationState.user.user_id, action: 'DELETED' },
          error: error
        },
        myuuid
      )
      requestFailure('Ocurrió un error, intente nuevamente')
      return 'error'
    }
  }
  // unasubscriber user
  const handleUnasubscriberUser = async (myuuid, suscriberId) => {
    const data = {
      subscriber_id: suscriberId,
      user_id: organizationState.user?.user_id
    }
    try {
      await unassignUserSubscriberCorpEntity(data)
      await logEvent('CGI - unassignUserSubscriberCorpEntity', data, myuuid)
    } catch (error) {
      await logEvent(
        'CGI - unassignUserSubscriberCorpEntity',
        { body: data, error: error },
        myuuid
      )
      !error.response.data.message.includes('No existe la asociacion')
        ? requestFailure('Ocurrió un error, no existe la asociación')
        : requestFailure('Ocurrió un error, intente nuevamente')
      return 'error'
    }
  }
  // delete user of suscriber
  const handleDeleteUserOfSuscriber = async () => {
    setLoading(true)
    handleCloseModalDisableUser()
    const myuuid = uuidv4()
    const suscriber = await handleGetSuscriber()
    if (suscriber && organizationState.user) {
      if (isSameUserLogged(organizationState.user.user_id)) {
        requestFailure('Un usuario no se puede dar de baja a si mismo')
        return
      }
      const user = await getLogginAccountID(organizationState.user.user_id)
      if (user === 'error') {
        return
      }

      const changeStatusRequest = await handleChangeStatusUser(myuuid)
      if (changeStatusRequest === 'error') {
        return
      }
      const deleteUser = await handleUnasubscriberUser(
        myuuid,
        suscriber.subscriber_id
      )
      if (deleteUser === 'error') {
        return
      }
      // try {
      //   const body = {
      //     suscriberId: ,
      //     email: organizationState.user?.login_account?.email,
      //     firstName: organizationState.user?.login_account?.first_name,
      //     lastName: organizationState.user?.login_account?.last_name
      //   }
      //   const response = await deleteUserLegacyEntity(body)
      //   console.log(response)
      // } catch (err) {
      //   console.log(err)
      // }
    }
    //  COMPLETE WITH deleteUserLegacyEntity REQUEST*****
    // snackbar Request Success active
    dispatch(setRequestTextSnackBar())
    dispatch(setSuccessTextSnackBar('Usuario dado de baja con éxito'))

    setLoading(false)
    setTimeout(() => {
      refreshPage()
    }, 1000)
  }
  return (
    <div>
      <Modal
        open={openModalDisableUser}
        onClose={handleCloseModalDisableUser}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <CloseIcon
            sx={{
              fontSize: 'medium',
              ml: 50,
              color: '#263057',
              cursor: 'pointer'
            }}
            onClick={handleCloseModalDisableUser}
          />

          <Typography
            sx={{ fontFamily: 'Raleway', color: '#263057' }}
            id="modal-modal-title"
            variant="h6"
            component="h2"
          >
            Dar de baja al usuario
          </Typography>
          <Typography
            id="modal-modal-description"
            className={classes.deleteSuscriberTypography}
          >
            Se desvinculará al usuario, pero la cuenta seguirá existiendo.
          </Typography>
          <Box className={classes.buttons}>
            <ButtonConfirm
              handleDeleteUserOfSuscriber={handleDeleteUserOfSuscriber}
            />
            <ButtonClose
              handleCloseModalDisableUser={handleCloseModalDisableUser}
            />
          </Box>
        </Box>
      </Modal>
    </div>
  )
}
function ButtonConfirm ({ handleDeleteUserOfSuscriber }) {
  const classes = useStyleConfirmDisableSuscriber()

  return (
    <Box
      className={classes.disableButton}
      sx={{
        '&:hover': {
          bgcolor: '#1BF57F'
        }
      }}
      onClick={handleDeleteUserOfSuscriber}
    >
      <Typography className={classes.disableButtonTypography}>
        Dar de baja
      </Typography>
    </Box>
  )
}

function ButtonClose ({ handleCloseModalDisableUser }) {
  const classes = useStyleConfirmDisableSuscriber()

  return (
    <Box className={classes.closeButton}>
      <Typography
        onClick={() => {
          handleCloseModalDisableUser()
        }}
        className={classes.closeButtonTypography}
      >
        Cancelar
      </Typography>
    </Box>
  )
}
